module.exports = __webpack_public_path__ + "img/surgery_z6dmxf_c_scale,w_934.8d6c5311.jpg";